import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import BaseFoundation from '../base/foundation';
export default class AvatarFoundation extends BaseFoundation {
  constructor(adapter) {
    super(_Object$assign({}, adapter));
  }

  init() {} // eslint-disable-line


  destroy() {} // eslint-disable-line


  handleImgLoadError() {
    const {
      onError
    } = this.getProps();
    const errorFlag = onError ? onError() : undefined;

    if (errorFlag !== false) {
      this._adapter.notifyImgState(false);
    }
  }

  handleEnter(e) {
    this._adapter.notifyEnter(e);
  }

  handleLeave(e) {
    this._adapter.notifyLeave(e);
  }

}